import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/comments', data)
    .then(response => response.data)
}
function update(data, id) {
  return axios.patch(`/comments/${id}`, data)
    .then(response => response.data)
}

export default {
  fetch(params) {
    return axios.get('/comments', { params: params })
      .then(response => response.data)
  },
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  destroy(id) {
    return axios.delete(`/comments/${id}`)
  },
  togglePin(id) {
    return axios.get(`/comments/${id}/toggle-pin`)
  }
}
